module.exports = __webpack_public_path__ + "img/26_63.74735aaf.png";